export function calculateFuelUsedLiters(
  trip,
  vehicles
) {
  if (!trip) return null

  const distance = Number(
    String(trip.distanceKm ?? '').replace(',', '.')
  )

  if (!Number.isFinite(distance) || distance <= 0) {
    return null
  }

  const vehicle = vehicles.find(
    v => String(v.id) === String(trip.vehicleId)
  )
  if (!vehicle) return null

  const consumption = Number(
    String(vehicle.consumption ?? '').replace(',', '.')
  )

  if (!Number.isFinite(consumption) || consumption <= 0) {
    return null
  }

  return +((distance * consumption) / 100).toFixed(2)
}

export function calculateTripDurationMinutes(
  startIso,
  endIso
) {
  if (!startIso || !endIso) return null

  const start = new Date(startIso).getTime()
  const end = new Date(endIso).getTime()

  if (!Number.isFinite(start) || !Number.isFinite(end)) return null
  if (end <= start) return null

  return Math.round((end - start) / 60000)
}

export function calculateAvgSpeedKmh(trip) {
  if (!trip) return null

  const distance = Number(
    String(trip.distanceKm ?? '').replace(',', '.')
  )

  if (!Number.isFinite(distance) || distance <= 0) {
    return null
  }

  const minutes = calculateTripDurationMinutes(
    trip.startTimeIso,
    trip.endTimeIso
  )

  if (!Number.isFinite(minutes) || minutes <= 0) {
    return null
  }

  const hours = minutes / 60

  if (hours <= 0) return null

  return +(distance / hours).toFixed(1)
}

export function formatDurationHHMM(minutes) {
  if (!Number.isFinite(minutes) || minutes <= 0) return null

  const h = String(Math.floor(minutes / 60)).padStart(2, '0')
  const m = String(minutes % 60).padStart(2, '0')

  return `${h}:${m}`
}